import { IRegistrationActivity, IRegistrationActivityContext } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';

export class RegistrationActivity implements IRegistrationActivity {
  static build(registrationError: IRegistrationActivity) {
    return new RegistrationActivity(registrationError);
  }
  id: number;
  title: string;
  message: string;
  alert_type: string;
  context: IRegistrationActivityContext;
  created_ts: string;
  is_active: boolean;
  transaction_id: number;

  constructor(registrationActivity: IRegistrationActivity) {
    const activityContext = {
      section_id: -1,
      action: 'N/A',
      section_name: '',
      section_type: ''
    };
    _4.merge(this, { context: activityContext }, registrationActivity);
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration_transactions/builders/registration_activity_builder.ts